import optimizedImages from '../content/optimized-images.json';

export function learningImageUrl(source: string) {
  return (optimizedImages as Record<string, string>)[source] ?? source;
}

export const worldBackgroundUrl = learningImageUrl('/assets/world/map/galaxy-route-c4d-v2.webp');

export function preloadWorldBackground() {
  if (document.querySelector('link[data-world-background]')) return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = worldBackgroundUrl;
  link.fetchPriority = 'high';
  link.dataset.worldBackground = 'true';
  document.head.append(link);
}
